"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewTab = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function NewTab(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), children, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 10.667V7a.333.333 0 00-.333-.333H11a.333.333 0 00-.333.333v3.667H1.333V1.333H5c.184 0 .333-.149.333-.333V.333A.333.333 0 005 0H1.333C.597 0 0 .597 0 1.333v9.334C0 11.403.597 12 1.333 12h9.334c.736 0 1.333-.597 1.333-1.333zM11.673.153l.18.18V.327a.5.5 0 01.147.34V5c0 .184-.15.333-.333.333H11A.333.333 0 0110.667 5V2.28L5.04 7.9a.333.333 0 01-.473 0L4.1 7.433a.333.333 0 010-.473l5.627-5.627H7A.333.333 0 016.667 1V.333C6.667.15 6.816 0 7 0h4.333a.5.5 0 01.34.153z",
    clipRule: "evenodd"
  }));
}

exports.NewTab = NewTab;